module.exports = __webpack_public_path__ + "img/service-overview-mobile-hero.9eec6a39.webp";